import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Draggable from 'react-draggable';

import { IcMaximizeIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import NoVideoMinimize from '../../SharedComponents/NoVideoMinimize';
import Video from '../../SharedComponents/Video';
import styles from './styles.m.css';

const MinimizeView = ({ presenter, isFinished }) => {
  const [isDragging, setDragging] = useState();
  useEffect(() => {
    if (isFinished) {
      presenter.onClose();
    }
  }, [isFinished]);
  return (
    <Draggable
      cancel="button"
      bounds={'body'}
      onStart={() => setDragging(false)}
      onDrag={() => setDragging(true)}
      onStop={() => setDragging(false)}
    >
      <div
        className={classNames(styles.container, {
          [styles.dragging]: isDragging,
          [styles.showControls]: !presenter.primaryVideo,
        })}
      >
        {presenter.primaryVideo ? (
          <Video videoTrack={presenter.primaryVideo} />
        ) : (
          <NoVideoMinimize />
        )}
        <IconButton
          Icon={IcMaximizeIcon}
          onClick={presenter.expand}
          className={styles.expand}
          size="large"
          iconSize="medium"
          theme="12"
        />
        {presenter.isStreamStarted && <div className={styles.live}>LIVE</div>}
      </div>
    </Draggable>
  );
};

export default observer(MinimizeView);
